import {
  SidePanel,
  SidePanelHeader,
  SidePanelContent,
} from '../../organisms/SidePanel/SidePanel';

/**
 * Batch side panel shell — reuses SidePanel with padded content for action cards.
 * @param {object} props
 * @param {boolean} props.isOpen - Whether the panel is open
 * @param {string} props.title - Header title
 * @param {number} [props.count=0] - Number of selected rows
 * @param {() => void} props.onClose - Close handler (header and Escape key)
 * @param {boolean} [props.closeOnEscape=true] - Whether Escape calls onClose (disable while a modal is open on top)
 * @param {import('react').ReactNode} props.children - Batch actions content
 * @param {import('react').ReactNode} props.footer - Footer slot (typically SidePanelFooter)
 * @returns {JSX.Element | null} BatchSidePanel component
 */
function BatchSidePanel({
  isOpen,
  title,
  count = 0,
  onClose,
  closeOnEscape = true,
  children,
  footer,
}) {
  return (
    <SidePanel
      isOpen={isOpen}
      size="batch"
      onClose={closeOnEscape ? onClose : undefined}
      usePortal
    >
      <SidePanelHeader
        title={title}
        count={count}
        onClose={onClose}
      />
      <SidePanelContent variant="batch">
        {children}
      </SidePanelContent>
      {footer}
    </SidePanel>
  );
}

export default BatchSidePanel;
